import { fetcher } from '@commenda/utils';
import { TransferPricingRedlineRequestHelper } from './transfer-pricing-redline-request-helper';
import type {
  ITransferPricingRedlineSubject,
  TTransferPricingRedlineResult,
} from './types';

/** Asks for one comparison. The endpoint renders on demand and holds the request open until the
 * vendor returns, so this is the paid call: run it once per click, never on a revalidation.
 *
 * The server answers with a single-key envelope; the comparison itself is handed back. */
export const requestTransferPricingRedline = async (
  subject: ITransferPricingRedlineSubject,
  versionId: string,
  token?: string
): Promise<TTransferPricingRedlineResult> => {
  const fallbackError =
    TransferPricingRedlineRequestHelper.FALLBACK_ERROR_MESSAGE;
  try {
    const response = await fetcher(
      TransferPricingRedlineRequestHelper.detailPath(subject, versionId),
      { method: 'GET' },
      token
    );
    const body: unknown = await response.json().catch(() => null);

    if (!response.ok) {
      return {
        success: false,
        error:
          TransferPricingRedlineRequestHelper.readServerMessage(body) ??
          fallbackError,
        status: response.status,
      };
    }
    if (!TransferPricingRedlineRequestHelper.isRedlineResponse(body)) {
      return { success: false, error: fallbackError, status: null };
    }

    return { success: true, data: body.redline };
  } catch (error) {
    console.error(error);
    return { success: false, error: fallbackError, status: null };
  }
};
